export interface TextInputOptions {
  clearOptions?: {
    minLenght: number;
  };
}

export class TextInput {
  private static LoadingClassName = 'input-group--loading';

  private readonly _groupElement: Element;
  private readonly _errorMessageElement: Element;
  private readonly _inputElement: HTMLInputElement;

  constructor(inputGroupElement: Element) {
    this._groupElement = inputGroupElement;

    this._errorMessageElement = this._groupElement.getElementsByClassName(
      'input-group__error-message'
    )[0];
    this._inputElement = this._groupElement.getElementsByTagName('input')[0]!;
  }

  public setIsLoading(isLoading: boolean) {
    if (isLoading) {
      this._groupElement.classList.add(TextInput.LoadingClassName);
    } else {
      this._groupElement.classList.remove(TextInput.LoadingClassName);
    }
  }

  public setError(message: string) {
    this._groupElement.classList.add('input-group--error');
    this._errorMessageElement.textContent = message;
  }

  public onFocusIn(callback: (value: string) => void) {
    $(this._inputElement).on('focusin', (e) => {
      callback(e.target.value);
    });
  }

  public focus() {
    this._inputElement.focus();
  }

  protected onChange(callback: (e: Event) => void) {
    this._inputElement.oninput = callback;
  }
}
